// extracted by mini-css-extract-plugin
export default {"wrapper":"fJmvWGghAh4HynSeabd2"};